var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text || _vm.$slots.default)?_c('div',{staticClass:"field__description"},[_vm._t("default"),(!_vm.$slots.default)?_c('p',{staticClass:"field__description",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }